import styled from 'styled-components';

export const ProductSelectionContainer = styled.div`
  min-width: 0;
  max-width: 100vw;
  overflow-x: scroll;
  display: flex;
  flex-wrap: no-wrap;
  padding: ${props => props.theme.spacing(0, 4)};
  gap: ${props => props.theme.spacing(4)};
  &::-webkit-scrollbar {
    display: none;
  }
  @media ${props => props.theme.laptop} {
    padding: 0;
    margin: ${props => props.theme.spacing(0, 'auto', 10, 'auto')};
    width: min-content;
    gap: ${props => props.theme.spacing(5)};
  }
`;

export const ProductCardWrapper = styled.div`
  display: grid;
  grid-auto-rows: minmax(220px, auto);
  min-width: min-content;
  :first-child {
    margin-left: ${props => props.theme.spacing(5)};
  }
  :last-child {
    /* border is needed to replace margin due to how box-model collapsing margins */
    border-right: ${props => props.theme.spacing(5)} solid transparent;
  }
`;
